// Keuzeantwoorden van activiteitsregistraties (EventResults) per optie geteld,
// voor de keuzegrafiek van een activiteit (EventMultipleData).
//
// Nodig omdat EventMultipleData 'Anders, namelijk' herkende aan OptionType, en
// dat veld staat niet op een registratie: alleen de optie waar OptionID naar
// wijst zegt dat het 'other' is (gemeten 2026-10-15: 11 van 640, 0 met
// OptionType). Daardoor werd elk getypt antwoord een eigen balk, met de tekst
// van de invuller als naam. De naam komt daarom altijd uit de optie, nooit uit
// de opgeslagen Value — dezelfde regel als de outputtooltip (choiceLabel).

// AI-CONTEXT: See docs/pitfalls.md#security-free-text-hides-in-a-choice-answer
import { OTHER_DISPLAY_LABEL } from './countMultipleOptions'
import { choiceLabel } from './summarizeOutputFields'

/**
 * @typedef {object} ChoiceBucket
 * @property {string} name - Naam van de optie; 'Anders, namelijk..' voor de 'Anders'-optie
 * @property {string} optionId - ID van de optie; '__other__' voor 'Anders' (kleurkeuze)
 * @property {number} count - Aantal antwoorden
 * @property {boolean} isOther - De 'Anders, namelijk'-optie
 */

/**
 * @param {Array<{ OptionID?: string, Value?: * }>} records - Keuzeantwoorden op één veld
 * @param {Object<string, { ID?: string, Option?: string }>} optionsById - MultipleQuestionOptions op ID
 * @returns {ChoiceBucket[]} Meest gekozen eerst, bij gelijkspel op naam
 */
const bucketEventChoices = (records, optionsById) => {
    /** @type {Map<string, ChoiceBucket>} */
    const buckets = new Map()

    ;(records || []).forEach((r) => {
        const option = optionsById?.[r?.OptionID]
        const label = choiceLabel(option)
        // Onbekende optie: niet te zeggen of Value een optienaam of vrije tekst is.
        if (label === null) return
        const isOther = option.Option === 'other'
        const optionId = isOther ? '__other__' : (option.ID || r.OptionID)
        if (!buckets.has(optionId)) {
            buckets.set(optionId, { name: isOther ? OTHER_DISPLAY_LABEL : label, optionId, count: 0, isOther })
        }
        buckets.get(optionId).count += 1
    })

    return [...buckets.values()]
        .sort((a, b) => (b.count - a.count) || a.name.localeCompare(b.name))
}

export default bucketEventChoices
